import { render } from "./Terms.vue?vue&type=template&id=4c9560ee&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=4c9560ee&lang=css"
import "./Terms.vue?vue&type=style&index=1&id=4c9560ee&scoped=true&lang=css"

import exportComponent from "/home/claude/weedborncounty/weedborncounty/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9560ee"]])

export default __exports__